// NO EDITAR A MANO
import soportados, {type Langs} from "../../langs";

export type CmpAutoAcceptWindowAawMainMessageParam = "url_privacidad";

export type CmpAutoAcceptWindowAawMainMessageParams = Record<CmpAutoAcceptWindowAawMainMessageParam, string>;

export interface CmpAutoAcceptWindow {
    aaw_main_message: (params?: Partial<CmpAutoAcceptWindowAawMainMessageParams>)=>string;
    aaw_open_config: string;
}

const loader = async function(lang: Langs, defecto?: string): Promise<CmpAutoAcceptWindow> {
    let langToImport = soportados.indexOf(lang)<0 ? (defecto||'en') : lang;

    return import(/* webpackChunkName: "i18n/[request]/cmp.auto_accept_window" */ `../../.src/${langToImport.replace("-", "")}/cmp/auto_accept_window`).then(module=> module.default);
}

export default loader;
